const filmsEnProd = [
  { 
    id: "Melody_for_a_bear",  
    titre: "Melody for a bear",
    annee: ["En post-production", "In post-production"],
    realisateur: "Gilles de Maistre",
    acteurs: "Eva Madeleine Cinq-Mars, Lucas Bravo, Morgan Holmstrom",
    production: ["Pathé Films"]
  }
]

export default filmsEnProd;